module.exports = __webpack_public_path__ + "static/media/on_hover_p.49cdd3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/on_hover_p.png
// module id = 130
// module chunks = 0